import React from 'react';
import { contactInfo } from '../data/mock';
import { MapPin, Phone, Mail, Instagram, FileText } from 'lucide-react';

const Contact = ({ onOpenAnamnese }) => {
  return (
    <section id="contact" className="section-padding contact-section">
      <div className="container">
        <div className="contact-wrapper">
          <div className="contact-info fade-in-left">
            <h2 className="hero-medium">Contact & Réservation</h2>
            <p className="body-large contact-intro">
              Prenez rendez-vous en ligne ou contactez-nous pour toute question.
            </p>

            <div className="contact-details">
              <div className="contact-item">
                <MapPin size={20} className="contact-icon" />
                <div>
                  <p className="body-regular">{contactInfo.location}</p>
                  <p className="body-small contact-note">{contactInfo.locationNote}</p>
                  <p className="body-small contact-home-service">{contactInfo.homeService}</p>
                </div>
              </div>

              <div className="contact-item">
                <Phone size={20} className="contact-icon" />
                <a href={`tel:${contactInfo.phone}`} className="body-regular contact-link">
                  {contactInfo.phone}
                </a>
              </div>

              <div className="contact-item">
                <Mail size={20} className="contact-icon" />
                <a href={`mailto:${contactInfo.email}`} className="body-regular contact-link">
                  {contactInfo.email}
                </a>
              </div>

              <div className="contact-item">
                <Instagram size={20} className="contact-icon" />
                <a 
                  href={contactInfo.instagramUrl} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="body-regular contact-link"
                >
                  {contactInfo.instagram}
                </a>
              </div>
            </div>
          </div>

          <div className="contact-cta fade-in-right">
            <div className="cta-card">
              <FileText size={48} className="cta-icon" />
              <h3 className="heading-1">Réservez votre séance</h3>
              <p className="body-regular cta-description">
                Étape 1 : Remplissez le questionnaire médical de sécurité<br />
                Étape 2 : Prenez rendez-vous après validation
              </p>
              <div className="cta-buttons">
                <button 
                  onClick={onOpenAnamnese}
                  className="btn-primary cta-button"
                >
                  <FileText size={18} style={{ marginRight: '8px' }} />
                  Commencer le Questionnaire
                </button>
                <p className="body-small cta-note">
                  Le lien de réservation vous sera donné après validation du questionnaire
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;